import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import classNames from "classnames";
import { useTranslations } from "../../../../providers/useTranslations";
import { InputInfoSection } from "./InputInfoSection";
import { InputLabel } from "./InputLabel";
import styles from "./InputWrapper.module.scss";
const themeClass = {
    dark: "dark-theme",
    light: "light-theme",
};
export const InputWrapper = forwardRef(({ dataTestId = "textInput", htmlFor, id, theme, label, helperText, isHelperTextVisible = false, isError, errorText, isSuccess, successText, isOptional, containerClassName, wrapperClassName, showRequiredAsterisk, labelId, children, }, ref) => {
    const { __ } = useTranslations();
    const displayedText = useMemo(() => {
        if (isSuccess && successText) {
            return successText;
        }
        if (isError && errorText) {
            return errorText;
        }
        return helperText;
    }, [errorText, helperText, isError, isSuccess, successText]);
    const optionalLabelText = isOptional ? __("form_fields.optional") : "";
    const displayedLabel = `${label} ${showRequiredAsterisk ? "*" : optionalLabelText}`;
    const isInfoSectionVisible = Boolean(isHelperTextVisible && displayedText);
    return (_jsxs("div", { ref: ref, className: classNames(styles.container, themeClass[theme], containerClassName), "data-testid": dataTestId, children: [label && (_jsx(InputLabel, { htmlFor: htmlFor, id: id, labelId: labelId, children: displayedLabel })), _jsx("div", { "data-testid": "textInputWrapper", className: classNames(styles.wrapper, wrapperClassName, {
                    [styles.wrapperError]: isError,
                    [styles.wrapperSuccess]: isSuccess,
                }), children: children }), isInfoSectionVisible && _jsx(InputInfoSection, { text: displayedText, isError: isError, isSuccess: isSuccess })] }));
});
//# sourceMappingURL=InputWrapper.js.map